/* eslint-disable import/first */
import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
const { selectCountryValidations } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import AccordionIcon from './images/dropdown filled icon.svg';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import CartValues from '../Cart/CartValues';
import CartItemInfo from './CartItemInfo';

const CartValue = ({ cart, setReviewPop }) => {
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const cartList = cart.data?.items;
  const vatPercentage = countryValidations?.constants?.cartAmount?.find(
    (each) => each.name === 'TAX'
  );
  const countOfItems = cart.data?.items?.reduce((a, { qty }) => a + qty, 0);
  // const setError = (error) => {
  //   setReviewPop((prev) => error);
  // };
  React.useEffect(() => {
    // let ItemName = [];
    const errorList = cartList.filter((item) => item.errMsg && item.errMsg !== '');
    if (errorList.length) {
      setReviewPop((prev) => errorList[0].errMsg);
    } else {
      setReviewPop((prev) => '');
    }
  }, [cartList, setReviewPop]);
  let newAr = cartList.map((item, index, arr) => {
    return item.qty + ' ' + item.name || item.additionalInfo?.name;
  });
  return (
    <div className={css.wrapperCartValues}>
      <div className={css.orderDetail}>
        <div className={css.orderItem}>
          <div className={css.itemCount}>
            <span>{countOfItems} </span>
            <span>
              {cart.count === 1 && <FormattedMessage id="checkout_item" defaultMessage="Item" />}
              {cart.count > 1 && <FormattedMessage id="checkout_items" defaultMessage="Items" />}
            </span>
          </div>
          <br />
          <div className={css.itemDetail}>
            {/* {cartList?.map((value, index) => {
              return ;
            })} */}
            {newAr.join(', ')}
          </div>
        </div>

        <Accordion className={css.orderTotal}>
          <AccordionSummary
            className={css.orderSummary}
            // eslint:fix alt is added in img tag
            expandIcon={<img src={AccordionIcon} alt="" />}
            id="panel1a-header"
          >
            <div className={css.amountText}>
              <FormattedMessage id="checkout_amount" defaultMessage="Total" />
            </div>
            <div className={css.amountValue}>
              <span>{decimalChecker(cart.cartValue)} </span>
              <span>{countryValidations?.currency}</span>
            </div>
          </AccordionSummary>
          <AccordionDetails className={css.orderInfo}>
            <CartValues amountObj={cart?.data?.amount} currency={countryValidations?.currency} />
            {/* {cart?.data?.amount.map((cartAmount, idx) => (
              <div className={css.listItem} key={idx}>
                <div className={css.textDetail}>{cartValues[cartAmount.type]}</div>
                <div className={css.amountDetail}>
                  {cartAmount.action === 'subtract' && '- '}
                  {cartAmount.amount} AED
                </div>
              </div>
            ))} */}
            {countryValidations.isVatEnabled ? (
              <div className={css.vatInfo}>
                {vatPercentage?.value} {cart?.data?.vat?.amount} {countryValidations?.currency}
              </div>
            ) : (
              ''
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default CartValue;
